import React, { useEffect, useMemo, useState } from 'react'
import Select from '../../../shared/Select'

const VariantFilterPopover = ({ onApply, togglePopover, variantFilter, selectedFilters }) => {
  const keys = useMemo(() => Object.keys(variantFilter || {}), [variantFilter])

  const optionsMap = useMemo(() => {
    const map = {}
    keys.forEach((k) => {
      const v = variantFilter[k]
      const arr = Array.isArray(v) ? v : Array.from(v || [])
      const unique = Array.from(new Set(arr))
      map[k] = ['All', ...unique]
    })
    return map
  }, [keys, variantFilter])

  const [selected, setSelected] = useState(() => {
    const init = {}
    Object.entries(optionsMap).forEach(([k, arr]) => {
      const saved = selectedFilters?.[k]
      init[k] = saved && arr.includes(saved) ? saved : arr?.[0] || ''
    })
    return init
  })

  useEffect(() => {
    setSelected((prev) => {
      const next = {}
      Object.entries(optionsMap).forEach(([k, arr]) => {
        next[k] = prev[k] && arr.includes(prev[k]) ? prev[k] : arr?.[0] || ''
      })
      return next
    })
  }, [optionsMap])

  // Sync when parent provides new saved selections
  useEffect(() => {
    if (!selectedFilters) return
    setSelected((prev) => {
      const next = { ...prev }
      Object.entries(optionsMap).forEach(([k, arr]) => {
        const saved = selectedFilters[k]
        next[k] = saved && arr.includes(saved) ? saved : next[k]
      })
      return next
    })
  }, [selectedFilters, optionsMap])

  const handleChange = (key) => (e) => {
    const value = e.value
    setSelected((prev) => ({ ...prev, [key]: value }))
  }

  const handleSave = () => {
    if (onApply) onApply(selected)
    if (togglePopover) togglePopover()
  }

  return (
    <div className="variant-filter-popover">
      <div className="mb-3">
        <h6 className="text-start mb-0">Variant Filters</h6>
      </div>
      {keys.map((key) => (
        <div className="mb-3 filter-item" key={key}>
          <label className="form-label">{key}:</label>
          <Select
            className="select-variants-filter"
            options={optionsMap[key].map((v) => ({ label: v, value: v }))}
            value={{ label: selected[key], value: selected[key] }}
            onChange={handleChange(key)}
          />
        </div>
      ))}

      <div className="d-flex justify-content-end gap-2">
        <button type="button" className="btn btn-light" onClick={togglePopover}>
          Cancel
        </button>
        <button type="button" className="btn btn-primary" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  )
}

export default VariantFilterPopover
